import { ConvertDate } from "../../utils/date";

const state = {}

const mutations = {};

const actions = {
    /**
     * 获取新闻列表
     * @param {*} param0 
     * @param {*} queryData 
     * queryData:{
          Moudel: 'meeting', //notice：通知；meeting：会议；trends：动态；
          Title: '',
          ContentType: '',
          Status: '',
          PageIndex: 1,
          PageSize: 20
        }
     */
    async loadNewsList({ commit }, queryData) {
        let res = await this.$post(
            '/NewsInfo/QueryData',
            queryData
        );
        res.data.forEach(item => {
            item.contentType = item.contentType == '1' ? '链接' : '文本';
            item.statusStr = item.status == '0' ? '新增' : item.status == '1' ? '公示' : '无效';
            item.createTime = ConvertDate(item.createTime);
        });
        return res;
    },
    //保存新闻
    async saveNews({ commit }, data) {
        var url = data.Id > 0 ? '/NewsInfo/UpdateData' : '/NewsInfo/AddData';
        let res = await this.$post(
            url,
            data
        );
        return res;
    },
    //删除新闻
    async deleteNews({ commit }, Id) {
        let res = await this.$post(
            '/NewsInfo/DeleteData', { Id: Id }
        );
        return res;
    },
    //获取明细
    async loadNewsDetail({ commit }, Id) {
        let res = await this.$post(
            '/NewsInfo/QueryDataById', { Id: Id }
        );
        return res;
    },
    //获取中心简介
    async loadIntroduction({ commit }) {
        let res = await this.$post(
            '/NewsInfo/QueryDataIntroduction'
        );
        return res;
    },
    //发布
    async publish({ commit }, Id) {
        let res = await this.$post(
            '/NewsInfo/PublishNews', { Id: Id }
        );
        return res;
    },
    //加载首页图片
    async loadHomeImage({ commit }) {
        var res = await this.$post(
            '/SysImage/QueryData', {}
        );
        return res;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}